export const constants = {
  BASE_URL:process.env.REACT_APP_BASE_URL,     // FOR APIs                 
  DOMAIN_URL:process.env.REACT_APP_DOMAIN_URL,      // FOR OAuths and redirects
  SEO_URL:"https://dev.showstage.in/",          // FOR SHARE AND SEOs

  FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID,
  FACEBOOK_APP_SECRET: process.env.REACT_APP_FACEBOOK_APP_SECRET,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  LINKEDIN_CLIENT_ID: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
  LINKEDIN_CLIENT_SECRET: process.env.REACT_APP_LINKEDIN_CLIENT_SECRET,
  FACEBOOK_CLIENT_ID: process.env.REACT_APP_FACEBOOK_CLIENT_ID,
  TWITTER_CLIENT_ID: process.env.REACT_APP_TWITTER_CLIENT_ID,
  TWITTER_CLIENT_SECRET: process.env.REACT_APP_TWITTER_CLIENT_SECRET,
  INSTAGRAM_APP_SECRET: process.env.REACT_APP_INSTAGRAM_APP_SECRET,
  INSTAGRAM_APP_ID: process.env.REACT_APP_INSTAGRAM_APP_ID,
  INSTAGRAM_CLIENT_TOKEN: process.env.REACT_APP_INSTAGRAM_CLIENT_TOKEN,
  RAZORPAY_KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID,
  RAZORPAY_KEY_SECRET: process.env.REACT_APP_RAZORPAY_KEY_SECRET,
  S3_URL : process.env.REACT_APP_CDN_URL,

  LOGIN_URL: "auth/login",
  SIGN_UP: "auth/register",
  SAVE_AGENCY:"agency/saved-agency",
  GOOGLE_MOBILE_SIGN_IN:"auth/google",
  OTP_VERIFICATION: "auth/verifyOtp",
  RESEND_OTP: "auth/resendOtp",
  FORGOT_PASSWORD: "auth/forgot-password",
  CREATE_PASSWORD: "auth/create-password",
  AGENCY_SIGN_UP:"auth/agency-register",
  UPDATE_EMAIL: "auth/updateEmail",
  GET_ARTIST_TYPE: "artistCategory/list",
  GET_ARTIST_SUBTYPE: "artistCategory/list",
  PRE_LOGIN_PROFILE_UPDATE: "profile/preLoginProfileUpdate",
  GET_PRE_SIGNED_URL: "media/getPreSignedUrlToUploadMedia",
  GET_GOOGLE_USER_PROFILE: "https://www.googleapis.com/oauth2/v1/userinfo",
  LOGIN_WITH_GOOGLE: "auth/google",
  LOGIN_WITH_FACEBOOK: "auth/facebook",
  GET_PROFILE_DETAILS: "profile/getProfile",
  GET_PUBLIC_PROFILE_DETAILS: "public/profile",
  SAVE_PROFILE_DETAILS: "profile/saveProfile",
  ADD_PROFILE: "profile/addProfile",
  UPDATE_PROFILE: "profile/update-Profile",
  SAVE_PROFILE_SETTINGS: "profile/saveSettings",
  GET_USER_SETTINGS: "profile/getSettings",
  GET_ARTIST_LIST: "artist/list",
  ARTIST_DETAILS: "artistCategory",
  GET_PUBLIC_PROFILE: "public/profile/artist",
  LIST_JOBS:"job/list",
  LIST_COMPETITIONS:"competitions/list",
  LIST_SCRIPTS:"others/scripts/list",
  LIST_INSTITUTIONS:"others/institutions/list",
  HELP_AND_SUPPORT: "/public/help-support",

};


// FACEBOOK_APP_ID=1095350479287103
// FACEBOOK_APP_SECRET=c066023168be4dc84643567c84bce012
// GOOGLE_CLIENT_ID=709524912491-ej2ajc3lqdb7029834skj54sfe6j0507.apps.googleusercontent.com
// LINKEDIN_CLIENT_ID=86wuqxse9l9fqg
// LINKEDIN_CLIENT_SECRET=WPL_AP1.g13AMouQSXhPO0js.wBcDnw==
// FACEBOOK_CLIENT_ID=e3299a4a1e38c13e58fcbb5f90198efe
// TWITTER_CLIENT_ID=eWRySkpfcmVyQjhhdzN6ckxqaFA6MTpjaQ
// TWITTER_CLIENT_SECRET=735Lu4YmkFGU6iQ_0s78r9MzEIQEifJPfnMJuNfum9T2y2ro0p
// INSTAGRAM_APP_SECRET=632658eb4a45e7958e2317987f0a3b0d
// INSTAGRAM_APP_ID=715752887675776
// INSTAGRAM_CLIENT_TOKEN=be66436a2e3bdc2bcf39ddb30035bfb2
// =rzp_test_Rg19yeyW8Pvxpt
// RAZORPAY_KEY_SECRET=Tbm3jcFZsdYq9YLroIa0wq5a
